// Style
import "@/assets/css/main.css";

// Plugins
import { registerPlugins } from "./plugins/index";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";
import { registerFilters } from "./filters";

const app = createApp(App);
registerPlugins(app);
registerFilters(app);

console.log("running: " + import.meta.env.VITE_APP_MODE);
app.mount("#app");

// userStore.bootstrap().then(async () => {

// 	console.log('Successfully bootstrapt application');

// 	if (await userStore.checkAdminAccess()) {
// 		app.mount('#app');
// 	} else {
// 		console.log('No access granted.')
// 	}

// }).catch((e) => console.log('Error during bootstrapping: ' + e))
